import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { reloadPage } from '../../core/utils/reload';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { CardComponent } from '../../shared/components/card/card.component';
import { IconComponent } from '../../shared/components/icon/icon.component';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-sync-error',
  imports: [CardComponent, IconComponent, ButtonComponent, TranslatePipe],
  templateUrl: './sync-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sync-error.component.css',
})
export class SyncErrorComponent {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  retry(): void {
    reloadPage('user clicked retry on sync-error page');
  }

  logout(): void {
    this.authService.logout();
  }
}
